import React from "react";
import "./ScreenHeading.css";
import {FormattedMessage} from 'react-intl';

export default function ScreenHeading(props) {
  return (
    <div className="heading-container">
      <div className="screen-heading">
        <span><FormattedMessage id={props.title} /></span>
      </div>
      {props.subHeading ? (
        <div className="screen-sub-heading">
          <span><FormattedMessage id={props.subHeading} /></span>
        </div>
      ) : (
        <div></div>
      )}
      <div className="heading-seperator">
        <div className="seperator-line"></div>
        <div className="seperator-blob">
          <div></div>
        </div>
      </div>
    </div>
  );
}
